import type { SectionsPropsType } from '../../sections/types';
import { wallFadingSection } from './sections/wallFading';
import { wallMoldSection } from './sections/wallMold';
import { wallChalkingSection } from './sections/wallChalking';
import { wallCrackSection } from './sections/wallCrack';
import { wallPeelingSection } from './sections/wallPeeling';
import { wallDeteriorationEvaluationSection } from './sections/wallDeteriorationEvaluation';

export const wallDeteriorationBundle = async (props: SectionsPropsType) => {
  // 劣化診断_色あせ
  await wallFadingSection(props);

  // 劣化診断_カビ・コケ
  await wallMoldSection(props);

  // 劣化診断_チョーキング
  await wallChalkingSection(props);

  // 劣化診断_ひび割れ
  await wallCrackSection(props);

  // 劣化診断_剥がれ
  await wallPeelingSection(props);

  // 劣化診断_総評
  await wallDeteriorationEvaluationSection(props);
};
